import { initSnapSuccessAction, setActiveTabAction } from 'containers/Snaps/Snap/store';

import { SnapDetails } from 'codegen';
import { IDataResponse, TFieldProps } from 'types';

export const handleEscalateSuccess = (
  onCancel: () => void,
  activeKey?: string,
) => (
  { data }: IDataResponse<SnapDetails>,
) => {
  onCancel();
  initSnapSuccessAction(data);

  if (activeKey === '4') {
    setActiveTabAction('1');
  }
};

export const fields: TFieldProps[] = [{
  type: TFieldProps.type.Textarea,
  name: 'comment',
  maxLength: 256,
  showCount: true,
  itemClassName: '!mb-5',
  placeholder: 'Write comment',
  autoSize: {
    minRows: 5,
    maxRows: 5,
  },
  rules: [{
    required: true,
    message: 'Comment is required!',
  }, {
    min: 5,
    message: 'Min length should be 5 symbols!',
  }, {
    max: 256,
    message: 'Max length should be 256 symbols!',
  }],
}];
